/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyOrId } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import {
	createResource,
	useResource,
	type RouteResource,
	type UseResourceHookResponse,
} from '@atlassian/react-resource-router';
import type { HelpCenterJirafield } from './getData.tsx';

export const formEditJirafieldsResource: RouteResource<HelpCenterJirafield> =
	createResource<HelpCenterJirafield>({
		type: 'HELP_CENTER_FORM_EDIT_JIRAFIELDS_RESOURCE',
		getKey: ({ match }) => getProjectKeyOrId(match),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "help-center/form-edit-jirafields-resource", jiraSpaEntry: help-center/form-edit-jirafields-resource" */ './getData.tsx'
			),
		isBrowserOnly: true,
	});

export const useFormEditJirafields = (): UseResourceHookResponse<HelpCenterJirafield> =>
	useResource<HelpCenterJirafield>(formEditJirafieldsResource);
